import { render, staticRenderFns } from "./ExportInspectionsExcel.vue?vue&type=template&id=68e94f8c&scoped=true&"
import script from "./ExportInspectionsExcel.vue?vue&type=script&lang=ts&"
export * from "./ExportInspectionsExcel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e94f8c",
  null
  
)

export default component.exports